import {
  Marquee,
  MarqueeItem,
  MarqueeFade,
  MarqueeContent
} from "@/components/ui/marquee"

const BrandsMarquee = () => {
  const brands = [
    { name: "Arauco", image: "/images/Marcas/Arauco.png" },
    { name: "Canplast", image: "/images/Marcas/canplast.png" },
    { name: "Duraplay", image: "/images/Marcas/Duraplay.png" },
    { name: "Pantz", image: "/images/Marcas/pantz.png" },
    { name: "Sarotech", image: "/images/Marcas/sarotech.png" },
    { name: "Tecnotabla", image: "/images/Marcas/tecnotabla.png" },
    { name: "Tekno", image: "/images/Marcas/tekno.png" },
  ]

  return (
    <section className="relative py-12 bg-gradient-to-b from-background to-background/95">
      <div className="container mx-auto px-6">
        <h3 className="text-center text-2xl md:text-3xl font-bold mb-8 text-foreground">
          Marcas Premium
        </h3>
        <Marquee speed={40} pauseOnHover>
          <MarqueeFade side="left" />
          <MarqueeFade side="right" />
          <MarqueeContent>
            {[...brands, ...brands].map((brand, index) => (
              <MarqueeItem key={index} className="w-32 h-32 md:w-40 md:h-40">
                <img
                  src={brand.image}
                  alt={brand.name}
                  className="w-full h-full object-contain rounded-full hover:scale-105 transition-transform duration-300"
                />
              </MarqueeItem>
            ))}
          </MarqueeContent>
        </Marquee>
      </div>
    </section>
  )
}

export default BrandsMarquee




